const gmKidsConfig = JSON.parse(document.querySelector('[data-gm-kids-config]').textContent);

    window.PD_ENABLE_COLOR_SELECTION = gmKidsConfig.enableColor;
  (function(){
    var sectionId = gmKidsConfig.sectionId;
    var modal = document.getElementById('pd-modal-' + sectionId);
    var openBtn = document.querySelector('.pd-open-btn');
    var closeBtn = document.querySelector('.pd-close-btn');
    var downloadBtn = document.getElementById('pd-download-preview-' + sectionId) || null;

    var elementsContainer = document.getElementById('pd-elements-' + sectionId);
    var canvasEl = document.getElementById('pd-canvas-' + sectionId);
    var area = document.getElementById('pd-area-' + sectionId);
    var fileInput = document.getElementById('pd-file-' + sectionId);
    var addTextBtn = document.getElementById('pd-add-text-' + sectionId);
    var elementsList = document.getElementById('pd-elements-list-' + sectionId);
    var addCartBtn = document.getElementById('pd-add-cart-' + sectionId);
    var qtyInput = document.getElementById('pd-qty-' + sectionId);
    var qtyMinus = document.getElementById('pd-qty-minus-' + sectionId);
    var qtyPlus = document.getElementById('pd-qty-plus-' + sectionId);
    var baseImg = document.querySelector('#product-designer-' + sectionId + ' .pd-base-img');

        var upsellModal     = document.getElementById('pd-upsell-modal-' + sectionId);
    var upsellYesBtn    = document.getElementById('pd-upsell-yes-' + sectionId);
    var upsellNoBtn     = document.getElementById('pd-upsell-no-' + sectionId);
    var upsellQtyInput  = document.getElementById('pd-upsell-qty-' + sectionId);

    var hasUpsellProduct = false;
    var upsellVariantId = null;

    // Upsell-Elemente ERST holen, wenn DOM fertig ist
    function initUpsell() {
      var upsellModal    = document.getElementById('pd-upsell-modal-' + sectionId);
      var upsellYesBtn   = document.getElementById('pd-upsell-yes-' + sectionId);
      var upsellNoBtn    = document.getElementById('pd-upsell-no-' + sectionId);
      var upsellQtyInput = document.getElementById('pd-upsell-qty-' + sectionId);

      // Fallback: wenn kein Modal im DOM, direkt normal in den Warenkorb
      if (!addCartBtn) return;

      // Klick auf „IN DEN WARENKORB“ im Designer
      addCartBtn.addEventListener('click', function(e){
  e.preventDefault();

  // Wenn ein Upsell-Produkt konfiguriert ist → erst Upsell-Modal anzeigen
  if (hasUpsellProduct && upsellModal) {

    // 👉 Anzahl aus dem Designer übernehmen
    if (qtyInput && upsellQtyInput) {
      var mainQty = parseInt(qtyInput.value, 10) || 1;
      upsellQtyInput.value = mainQty;
    }

    upsellModal.hidden = false;
  } else {
    // Kein Upsell konfiguriert → direkt in den Warenkorb
    addToCart();
  }
});

      // ❌ „Nein, ohne Upsell in den Warenkorb“
      if (upsellNoBtn && upsellModal) {
        upsellNoBtn.addEventListener('click', function(){
          upsellModal.hidden = true;
          addToCart(); // nur Hauptprodukt
        });
      }

      // ✅ „Ja, Upsell mitnehmen“
      if (upsellYesBtn && upsellModal) {
        upsellYesBtn.addEventListener('click', function(){
          var extraItems = [];

          if (upsellVariantId) {
            var uq = upsellQtyInput ? parseInt(upsellQtyInput.value, 10) : 1;
            if (!uq || uq < 1) uq = 1;

            extraItems.push({
              id: upsellVariantId,
              quantity: uq
            });
          }

          upsellModal.hidden = true;
          addToCart(extraItems); // Hauptprodukt + Upsell
        });
      }
    }

    // Für normale PDP + evtl. AJAX-Templates
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initUpsell);
    } else {
      initUpsell();
    }


    var variantDataScript = document.getElementById('pd-variant-data-' + sectionId);
    var variantData = variantDataScript ? JSON.parse(variantDataScript.textContent) : { variants: [] };

    var elements = [];
    var nextId = 1;
    var selectedElId = null;
    var dragState = null;
    var selectionBox = null;
    var currentDesignDataUrl = null;
    var currentVariantId = null;
    var productForm = null;
    var isTouchInput = false;

    var productTitle = gmKidsConfig.title;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    var PD_FONTS = [
      {label:'Standard', family:"Arial,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif"},
      {label:'Alfa Slab One', family:"'Alfa Slab One', serif"},
      {label:'Anton', family:"'Anton', sans-serif"},
      {label:'Bebas Neue', family:"'Bebas Neue', sans-serif"},
      {label:'Bree Serif', family:"'Bree Serif', serif"},
      {label:'Cookie', family:"'Cookie', cursive"},
      {label:'DM Serif Display', family:"'DM Serif Display', serif"},
      {label:'Dancing Script', family:"'Dancing Script', cursive"},
      {label:'Fjalla One', family:"'Fjalla One', sans-serif"},
      {label:'Kaushan Script', family:"'Kaushan Script', cursive"},
      {label:'Libre Baskerville', family:"'Libre Baskerville', serif"},
      {label:'Lilita One', family:"'Lilita One', sans-serif"},
      {label:'Lobster', family:"'Lobster', cursive"},
      {label:'Noto Sans Arabic', family:"'Noto Sans Arabic', sans-serif"},
      {label:'Pacifico', family:"'Pacifico', cursive"},
      {label:'Permanent Marker', family:"'Permanent Marker', cursive"},
      {label:'Roboto', family:"'Roboto', sans-serif"},
      {label:'Satisfy', family:"'Satisfy', cursive"}
    ];

        // ==== NEU: exaktes Text-Layout mit Font-Metriken ====
    function pdSetCtxFont(ctx, el, fs){
      const fam = (el.fontFamily || 'Arial').replace(/"/g, "'");
      const wt  = (el.fontWeight != null ? el.fontWeight : 400);
      ctx.font  = wt + ' ' + fs + 'px ' + fam;
    }

    // Berechnet Zeilenumbruch + exakte vertikale Mitte wie im DOM
    function pdLayoutText(ctx, el, maxWidth){
      const fs = el.fontSize || 36;
      const lh = (el.lineHeight || 1.2) * fs;
      const text = el.content || '';
      const paras = text.split('\n');
      const lines = [];

      function wrapParagraph(p){
  lines.push(p);
}

      paras.forEach(wrapParagraph);
      if (!lines.length) lines.push('');

      let minY = Infinity;
      let maxY = -Infinity;
      const baselines = [];

      lines.forEach(function(line, idx){
        const baseY = idx * lh;
        baselines.push(baseY);

        pdSetCtxFont(ctx, el, fs);
        const m = ctx.measureText(line || ' ');
        const ascent  = m.actualBoundingBoxAscent  || fs * 0.8;
        const descent = m.actualBoundingBoxDescent || fs * 0.2;

        const topY = baseY - ascent;
        const botY = baseY + descent;

        if (topY < minY) minY = topY;
        if (botY > maxY) maxY = botY;
      });

      const centerY = (minY + maxY) / 2;

      return {
        fontSize: fs,
        lineHeightPx: lh,
        lines: lines,
        baselines: baselines,
        centerY: centerY
      };
    }


    function waitForUsedFonts(els){
  if(!('fonts' in document)) return Promise.resolve();
  const families=[...new Set(
    els.filter(e=>e.type==='text'&&e.fontFamily)
       .map(e=>e.fontFamily.split(',')[0].replace(/['"]/g,'').trim())
  )];
  // Normalgewicht laden (400)
  return Promise.all(families.map(f=>document.fonts.load(`400 32px "${f}"`)))
         .then(()=>document.fonts.ready);
}


    function findProductForm(){
      var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find(function(form){
        return form.querySelector('[type="submit"], button[name="add"]');
      }) || forms[0] || null;
    }

    function hideOriginalAddToCart(){
      var pf = productForm || findProductForm();
      if(!pf) return;
      var submitBtn = pf.querySelector('[type="submit"], button[name="add"]');
      if(submitBtn) submitBtn.style.display='none';
    }

function updateBaseImage(variantId){
  if(!variantId) return;
  currentVariantId = variantId;
  var v = (variantData.variants||[]).find(x => String(x.id) === String(variantId));
  var newSrc = v && v.preview_image ? v.preview_image : null;
  if(!newSrc) return;

  // 1️⃣ Haupt-Canvas updaten
  if (baseImg) baseImg.src = newSrc;

  // 2️⃣ Alle Popups (Farb- & Schrift-Popup) ebenfalls aktualisieren
  document.querySelectorAll('#pd-color-modal .pd-base-img, #pd-font-modal .pd-base-img')
    .forEach(img => { img.src = newSrc; });
}

function getTouchDistance(t1, t2){
  var dx = t2.clientX - t1.clientX;
  var dy = t2.clientY - t1.clientY;
  return Math.sqrt(dx*dx + dy*dy);
}


    function getCurrentVariantId(){
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariant = urlParams.get('variant'); if(urlVariant) return urlVariant;
      var pf = productForm || findProductForm();
      if(pf){
        var sel = pf.querySelector('select[name="id"]'); if(sel && sel.value) return sel.value;
        var rad = pf.querySelector('input[name="id"][type="radio"]:checked'); if(rad && rad.value) return rad.value;
        var hid = pf.querySelector('input[name="id"][type="hidden"]'); if(hid && hid.value) return hid.value;
      }
      if(window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) return window.ShopifyAnalytics.meta.selectedVariantId;
      return null;
    }

    var initialVariantId = getCurrentVariantId(); if(initialVariantId) updateBaseImage(initialVariantId);
    document.addEventListener('product:variant-change', function(e){ if(e.detail && e.detail.variant) updateBaseImage(e.detail.variant.id); });
    document.addEventListener('variant:change', function(e){ if(e.detail && e.detail.variant && e.detail.variant.id){ updateBaseImage(e.detail.variant.id); }});

    function setupVariantChangeListeners(){
      var pf = document.querySelector('form[action*="/cart/add"]'); if(!pf) return;
      pf.querySelectorAll('select[name="id"]').forEach(function(s){ s.addEventListener('change', function(){ updateBaseImage(this.value); });});
      pf.querySelectorAll('input[name="id"][type="radio"]').forEach(function(r){ r.addEventListener('change', function(){ if(this.checked) updateBaseImage(this.value); });});
      var hid = pf.querySelector('input[name="id"][type="hidden"]');
      if(hid){
        var obs = new MutationObserver(function(m){ m.forEach(function(x){ if(x.type==='attributes' && x.attributeName==='value') updateBaseImage(hid.value); });});
        obs.observe(hid, {attributes:true});
      }
    }
    setupVariantChangeListeners();
    setTimeout(setupVariantChangeListeners, 500);
    setTimeout(setupVariantChangeListeners, 1500);

    var lastUrl = location.href;
    new MutationObserver(function(){
      var url = location.href;
      if(url !== lastUrl){ lastUrl = url; var nv = getCurrentVariantId(); if(nv && nv !== currentVariantId) updateBaseImage(nv); }
    }).observe(document, {subtree:true, childList:true});

    openBtn && openBtn.addEventListener('click', async function(){
      document.body.appendChild(document.getElementById('product-designer-' + sectionId));
      modal.hidden = false; document.body.style.overflow = 'hidden';
      var header = document.querySelector('header, .header, [role="banner"]'); if(header) header.style.setProperty('display','none','important');
      document.querySelectorAll('[id*="trustbadge"], [id*="trusted"], ._1b4t9li, [class*="trustbadge"]').forEach(b=>b.style.setProperty('display','none','important'));
      // Live-Snapshot deaktiviert für bessere Performance auf Handy
      // await onElementsChanged();
    });


    closeBtn && closeBtn.addEventListener('click', function(){
      onDragEnd();
      modal.hidden = true; document.body.style.overflow = '';
      var header = document.querySelector('header, .header, [role="banner"]'); if(header) header.style.removeProperty('display');
      document.querySelectorAll('[id*="trustbadge"], [id*="trusted"], ._1b4t9li, [class*="trustbadge"]').forEach(b=>b.style.removeProperty('display'));
    });

    qtyMinus && qtyMinus.addEventListener('click', function(){ qtyInput.value = Math.max(1,(parseInt(qtyInput.value||1)-1)); });
    qtyPlus && qtyPlus.addEventListener('click', function(){ qtyInput.value = Math.min(999,(parseInt(qtyInput.value||1)+1)); });
    qtyInput && qtyInput.addEventListener('input', function(){ var v = Math.max(1, Math.min(999, parseInt(qtyInput.value)||1)); qtyInput.value = v; });

    addTextBtn && addTextBtn.addEventListener('click', function(){
      createElement('text');
      var lbl = document.getElementById('pd-add-text-label-' + sectionId);
      if(lbl && elements.some(e=>e.type==='text')) lbl.textContent = 'Weiteren Text hinzufügen';
    });

    fileInput && fileInput.addEventListener('change', handleImageUpload);

async function resizeImageFile(file, maxSize = 4000, quality = 0.92) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.onerror = reject;

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      // proportionale Skalierung
      if (width > height && width > maxSize) {
        height = height * (maxSize / width);
        width = maxSize;
      } else if (height > maxSize) {
        width = width * (maxSize / height);
        height = maxSize;
      }

      const canvas = document.createElement('canvas');
      canvas.width = Math.round(width);
      canvas.height = Math.round(height);
      const ctx = canvas.getContext('2d');

      // Transparenter Hintergrund für SVG & PNG
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // MIME-Type bestimmen
      const type = (file.type || '').toLowerCase();
      const isTransparent = /svg|png|webp|gif/i.test(type);
      const targetMime = isTransparent ? 'image/png' : 'image/jpeg';

      canvas.toBlob(
        (blob) => {
          if (!blob) return reject(new Error('Fehler beim Erstellen des Blobs'));
          const reader2 = new FileReader();
          reader2.onload = () => resolve(reader2.result);
          reader2.onerror = reject;
          reader2.readAsDataURL(blob);
        },
        targetMime,
        isTransparent ? undefined : quality
      );
    };

    img.onerror = reject;
    reader.readAsDataURL(file);
  });
}



    async function handleImageUpload(e){
      var file = e.target.files[0]; if(!file) return;
      let dataUrl;
      try{ dataUrl = await resizeImageFile(file,4000,0.92); }
      catch(err){
        const fr=new FileReader();
        dataUrl = await new Promise((res)=>{ fr.onload=(ev)=>res(ev.target.result); fr.readAsDataURL(file); });
      }
      createElement('image', dataUrl, null);
      fileInput.value='';
      // Hintergrund-Upload (base44 upload endpoint)
      try{
        const resp = await fetch('https://personalisierung.ecoverce.com/upload-design-geschenkemomente.php',{
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ dataUrl, category:'original' })
        });
        if(resp.ok){
          const j = await resp.json();
          if(j.fileUrl) updateElement(nextId-1, { uploadedImageUrl: j.fileUrl });
        }
      }catch(_e){}
    }

    function createElement(type, imageSrc, uploadedImageUrl=null){
      var id = nextId++;
      var el = { id, type, x:50, y:50, rotation:0, width:null, height:null };
      if(type==='text'){
        el.content='Neuer Text';
        el.fontSize=gmKidsConfig.fontSize;
        el.color=gmKidsConfig.textColor;
        el.fontFamily="Arial,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif";
        el.fontWeight=400; 
        el.lineHeight=1.2; el.letterSpacing=0; el.textAlign='center';
        el.width=200; el.height=el.fontSize*el.lineHeight;
      }else if(type==='image'){
        el.src=imageSrc; el.originalDataUrl=imageSrc; el.naturalWidth=null; el.naturalHeight=null;
        if(uploadedImageUrl) el.uploadedImageUrl=uploadedImageUrl;
      }
      elements.push(el);
      if (el.type === 'text') void window.PDDesignJSON.prepareFonts([el]);
renderElement(el);
renderAccordion(el);
selectElement(id);
updateReorderButtonsVisibility();

    }

    function renderElement(el){
      var dom = elementsContainer.querySelector('[data-id="'+el.id+'"]');
      if(!dom){
        dom = document.createElement('div');
        dom.className='pd-element';
        dom.dataset.id=el.id;
        elementsContainer.appendChild(dom);
        if(el.type==='image'){
          var img=document.createElement('img');
          img.className='pd-element-image';
          img.onload=function(){
            el.naturalWidth=img.naturalWidth; el.naturalHeight=img.naturalHeight;
            if(!el.width && el.naturalWidth && el.naturalHeight){
              el.width=100; el.height=100*(el.naturalHeight/el.naturalWidth);
            }
            updateElement(el.id,{});
          };
          img.src=el.src; dom.appendChild(img);
        }
      }
      dom.style.left=el.x+'%'; dom.style.top=el.y+'%';
      dom.style.transform='translate(-50%, -50%) rotate('+el.rotation+'deg)';
      if(el.type==='text'){
        dom.classList.add('pd-element-text');
        dom.textContent=el.content;
        dom.style.fontSize=el.fontSize+'px';
        dom.style.color=el.color;
        dom.style.fontFamily=el.fontFamily;
        dom.style.fontWeight = (el.fontWeight!=null? el.fontWeight : 400);
        dom.style.fontStyle = 'normal'; 
        dom.style.fontSynthesis = 'none'; 
        dom.style.lineHeight=el.lineHeight;
        dom.style.letterSpacing=el.letterSpacing+'px';
        dom.style.textAlign=el.textAlign;
        dom.style.width='auto';
        dom.style.minWidth='auto';
        dom.style.maxWidth='none';
      }else{
        var img=dom.querySelector('img'); if(img){
          img.style.width=(el.width||200)+'px';
          img.style.height=(el.height||200)+'px';
          img.style.minWidth=(el.width||200)+'px';
          img.style.minHeight=(el.height||200)+'px';
          img.style.maxWidth=(el.width||200)+'px';
          img.style.maxHeight=(el.height||200)+'px';
        }
      }
    }

    function renderAccordion(el){
      var acc=document.createElement('div'); acc.className='pd-accordion'; acc.dataset.id=el.id;

      var header=document.createElement('div'); 
header.className='pd-accordion-header';

var tWrap=document.createElement('div'); 
tWrap.style.flex='1';

var title=document.createElement('div'); 
title.className='pd-accordion-title'; 
title.textContent= el.type==='text'? el.content : 'Bild';

var meta=document.createElement('div'); 
meta.className='pd-accordion-meta'; 
meta.textContent= el.type==='text' 
  ? (el.fontSize+'px • '+el.rotation+'°') 
  : (Math.round(el.width||0)+'px • '+el.rotation+'°');

tWrap.appendChild(title); 
tWrap.appendChild(meta);

/* 🔼🔽 NEU: Controls-Container */
var controls = document.createElement('div');
controls.className = 'pd-accordion-controls';

var upBtn = document.createElement('button');
upBtn.type = 'button';
upBtn.className = 'pd-accordion-move pd-accordion-move-up';
upBtn.innerHTML = '▲';
upBtn.onclick = function(e){
  e.stopPropagation();
  moveElementLayer(el.id, 'up');
};

var downBtn = document.createElement('button');
downBtn.type = 'button';
downBtn.className = 'pd-accordion-move pd-accordion-move-down';
downBtn.innerHTML = '▼';
downBtn.onclick = function(e){
  e.stopPropagation();
  moveElementLayer(el.id, 'down');
};

var del=document.createElement('button'); 
del.className='pd-accordion-delete'; 
del.innerHTML='&times;';
del.onclick=function(e){ 
  e.stopPropagation(); 
  deleteElement(el.id); 
};

controls.appendChild(upBtn);
controls.appendChild(downBtn);
controls.appendChild(del);

header.appendChild(tWrap); 
header.appendChild(controls);

/* bleibt wie gehabt */
header.onclick=function(){ 
  if(acc.classList.contains('active')) selectElement(null); 
  else selectElement(el.id); 
};

      header.onclick=function(){ if(acc.classList.contains('active')) selectElement(null); else selectElement(el.id); };

      var content=document.createElement('div'); content.className='pd-accordion-content';

      if(el.type==='text'){
        // Textfeld, Größe, Breite
        content.innerHTML =
          // === TEXT ===
'<label class="pd-form-label">Wunschtext</label>' +
'<textarea class="pd-textarea" data-prop="content">' + el.content + '</textarea>' +

 // === BUTTONS (Schriftart + Farbe) ===
'<div class="pd-form-group pd-style-button-group">' +
  '<button type="button" class="pd-font-button" data-prop="fontFamily">' +
    '<span class="pd-font-icon">Aa</span>' +
    '<span class="pd-font-label">Schriftart</span>' +
  '</button>' +

'<button type="button" class="pd-color-button" data-prop="color">' +
        '<span class="pd-color-icon">A</span>' +
        '<span class="pd-color-line"></span>' +
        '<span class="pd-color-label">Farbe</span>' +
      '</button>' +
'</div>' +



 // === SCHRIFTGRÖSSE ===
'<label class="pd-form-label">Schriftgröße</label>' +
'<input type="range" class="pd-range" min="10" max="100" step="1" data-prop="fontSize" value="' + el.fontSize + '">'


        // Style-Buttons (Schriftart & Farbe)


        // Drehung
        var rot=document.createElement('div'); rot.className='pd-form-group';
        rot.innerHTML = '<label class="pd-form-label">Drehung: <span data-display="rotation">'+el.rotation+'</span>°</label>'+
                        '<input type="range" class="pd-range" data-prop="rotation" min="0" max="360" value="'+el.rotation+'">';
        content.appendChild(rot);

        // Inputs verdrahten
        content.querySelectorAll('[data-prop]').forEach(function(input){
          input.addEventListener('input', function(e){
            var prop=e.target.dataset.prop; var val=e.target.value;
            if(prop==='fontSize'||prop==='rotation'||prop==='width') val=parseInt(val);
            else if(prop==='lineHeight'||prop==='letterSpacing') val=parseFloat(val);
            var up={}; up[prop]=val;
            if(prop==='width'){ up.width=Math.max(20, Math.min(1000, val)); }
            updateElement(el.id, up);
            var dsp=content.querySelector('[data-display="'+prop+'"]');
            if(dsp){ dsp.textContent=(prop==='width')? Math.round(val) : val; }
            if (prop === 'content') {
  var preview = document.querySelector('.pd-font-preview');
  if (preview) preview.textContent = e.target.value || 'Aa – Beispieltext in gewählter Schrift';
}
          });
        });

        // Farb-/Font-Popup Buttons
        content.querySelector('.pd-color-button').addEventListener('click', function(){ openColorPopup(el); });
        content.querySelector('.pd-font-button').addEventListener('click', function(){ openFontPopup(el); });

      } else {
        // Bild
        content.innerHTML =
          '<div class="pd-form-group">'+
            '<label class="pd-form-label">Breite: <span data-display="width">'+Math.round(el.width||0)+'</span>px</label>'+
            '<input type="range" class="pd-range" data-prop="width" min="20" max="1000" value="'+Math.round(el.width||0)+'">'+
          '</div>'+
          '<div class="pd-form-group">'+
            '<label class="pd-form-label">Drehung: <span data-display="rotation">'+el.rotation+'</span>°</label>'+
            '<input type="range" class="pd-range" data-prop="rotation" min="0" max="360" value="'+el.rotation+'">'+
          '</div>';

        content.querySelectorAll('[data-prop]').forEach(function(input){
          input.addEventListener('input', function(e){
            var prop=e.target.dataset.prop; var val=parseInt(e.target.value);
            var up={}; if(prop==='width'){ up.width=val; var elx=elements.find(x=>x.id===el.id); if(elx && elx.naturalWidth && elx.naturalHeight){ up.height = val*(elx.naturalHeight/elx.naturalWidth); } }
            if(prop==='rotation'){ up.rotation=val; }
            updateElement(el.id, up);
            var dsp=content.querySelector('[data-display="'+prop+'"]'); if(dsp) dsp.textContent= Math.round(val);
          });
        });
      }

      acc.appendChild(header); acc.appendChild(content);
      elementsList.insertBefore(acc, elementsList.firstChild || null);
    }

    function updateElement(id, updates){
      var el = elements.find(x=>x.id===id); if(!el) return;
      if (updates && 'fontFamily' in updates && !('fontWeight' in updates)) {
  updates.fontWeight = 400;
}
      Object.assign(el, updates);
      if (el.type === 'text' && updates && 'fontFamily' in updates) {
        void window.PDDesignJSON.prepareFonts([el]);
      }
            renderElement(el);

      // Vorschau-Canvas in offenen Popups synchronisieren
      var colorModal = document.getElementById('pd-color-modal');
      if (colorModal && !colorModal.hidden) {
        syncCanvasToModal('pd-color-modal');
      }
      var fontModal = document.getElementById('pd-font-modal');
      if (fontModal && !fontModal.hidden) {
        syncCanvasToModal('pd-font-modal');
      }


      var acc = elementsList.querySelector('.pd-accordion[data-id="'+id+'"]');
      if(acc){
        var title=acc.querySelector('.pd-accordion-title');
        var meta =acc.querySelector('.pd-accordion-meta');
        if(el.type==='text'){
          if(title && updates.content!==undefined) title.textContent=el.content;
          if(meta) meta.textContent = el.fontSize+'px • '+el.rotation+'°';
        }else{
          if(meta) meta.textContent = Math.round(el.width)+'px • '+el.rotation+'°';
        }
      }
      updateSelectionBox();
    }

    function selectElement(id){
      if(id===null){
        selectedElId=null;
        document.querySelectorAll('.pd-accordion').forEach(a=>a.classList.remove('active'));
        removeSelectionBox();
        return;
      }
      var acc=elementsList.querySelector('.pd-accordion[data-id="'+id+'"]'); if(!acc){ selectedElId=null; removeSelectionBox(); return; }
      document.querySelectorAll('.pd-accordion').forEach(a=>{ if(parseInt(a.dataset.id)!==id) a.classList.remove('active');});
      acc.classList.add('active'); selectedElId=id; updateSelectionBox();
    }

    function deleteElement(id){
      elements = elements.filter(e=>e.id!==id);
      var dom = elementsContainer.querySelector('[data-id="'+id+'"]'); if(dom) dom.remove();
      var acc = elementsList.querySelector('.pd-accordion[data-id="'+id+'"]'); if(acc) acc.remove();
      if(selectedElId===id){ 
  selectedElId=null; 
  removeSelectionBox(); 
}
updateReorderButtonsVisibility();


    }

function moveElementLayer(id, direction){
  var index = elements.findIndex(function(e){ return e.id === id; });
  if (index === -1) return;

  // 🔁 WICHTIG: "up" soll Element NACH VORNE holen (höherer Index = weiter oben im Stack)
  var newIndex = direction === 'up' ? index + 1 : index - 1;
  if (newIndex < 0 || newIndex >= elements.length) return;

  // Array-Reihenfolge anpassen
  var el = elements.splice(index, 1)[0];
  elements.splice(newIndex, 0, el);

  // 🖼 Canvas-DOM in neuer Reihenfolge anordnen
  // -> elements[0] = ganz hinten, elements[last] = ganz vorne
  elements.forEach(function(e){
    var node = elementsContainer.querySelector('[data-id="'+e.id+'"]');
    if (node) elementsContainer.appendChild(node);
  });

  // 📚 Accordion-DOM so anordnen, dass
  //   GANZ OBEN in der Liste = GANZ VORNE im Canvas
  //   => Reihenfolge im Accordion = REVERSE vom Array
  elements.slice().reverse().forEach(function(e){
    var acc = elementsList.querySelector('.pd-accordion[data-id="'+e.id+'"]');
    if (acc) elementsList.appendChild(acc);
  });

  // Auswahl-Rahmen neu zeichnen, falls dieses Element selektiert ist
  if (selectedElId === id){
    updateSelectionBox();
  }

  updateReorderButtonsVisibility();
}


function updateReorderButtonsVisibility(){
  var show = elements.length > 1;
  var accordions = elementsList.querySelectorAll('.pd-accordion');

  accordions.forEach(function(acc, idx){
    var up  = acc.querySelector('.pd-accordion-move-up');
    var down= acc.querySelector('.pd-accordion-move-down');

    if(up){
      up.style.display = show ? '' : 'none';
      up.disabled = !show || idx === 0; // ganz oben → Up deaktiviert
    }
    if(down){
      down.style.display = show ? '' : 'none';
      down.disabled = !show || idx === accordions.length - 1; // ganz unten → Down deaktiviert
    }
  });
}


    function updateSelectionBox() {
  if (!selectedElId) { removeSelectionBox(); return; }

  var dom = elementsContainer.querySelector('[data-id="' + selectedElId + '"]');
  if (!dom) return;

  var elRect  = dom.getBoundingClientRect();
  var areaRect = area.getBoundingClientRect();
  var elData  = elements.find(function(e){ return e.id === selectedElId; });

  var box = selectionBox;
  if (!box || box.parentNode !== area) {
    removeSelectionBox();
    box = document.createElement('div');
    box.className = 'pd-selection-box';
  }

  // Ausgangswerte (volle Größe des Elements)
  var left   = elRect.left  - areaRect.left;
  var top    = elRect.top   - areaRect.top;
  var width  = elRect.width;
  var height = elRect.height;

  // 👉 Für Text-Elemente: Rahmen etwas enger ziehen
  if (elData && elData.type === 'text') {
    var factor = 1; // 0.9 = 90% der Größe, bei Bedarf auf 0.85 o.ä. anpassen

    // Mittelpunkt berechnen
    var centerX = left + width  / 2;
    var centerY = top  + height / 2;

    // Verkleinern
    width  = width  * factor;
    height = height * factor;

    // Wieder um denselben Mittelpunkt zentrieren
    left = centerX - width  / 2;
    top  = centerY - height / 2;
  }

  box.style.left   = left   + 'px';
  box.style.top    = top    + 'px';
  box.style.width  = width  + 'px';
  box.style.height = height + 'px';

  if (!box.parentNode) {
  ['tl','tr','br','bl'].forEach(function(p){
    var h = document.createElement('div');
    h.className = 'pd-handle pd-handle-' + p;
    h.dataset.handle = p;
    h.style.touchAction = 'none';
    box.appendChild(h);
  });

  var rot = document.createElement('div');
  rot.className = 'pd-handle-rotate';
  rot.textContent = '↻';
  rot.dataset.handle = 'rotate';
  rot.style.touchAction = 'none';
  box.appendChild(rot);

  area.appendChild(box);
  selectionBox = box;
  }
}

    function removeSelectionBox(){ if(selectionBox){ selectionBox.remove(); selectionBox=null; } }

    var touchMouseUntil = 0;

    function findTouch(touches, identifier) {
      for (var i = 0; i < touches.length; i++) {
        if (touches[i].identifier === identifier) return touches[i];
      }
      return null;
    }

    function canvasTouches(e) {
      return Array.prototype.filter.call(e.touches, function(touch) {
        return canvasEl && canvasEl.contains(touch.target);
      });
    }

    function startTouchDrag(e, id, action, handle, touch) {
      startDrag({
        clientX: touch.clientX,
        clientY: touch.clientY,
        preventDefault: function() { if (e.cancelable) e.preventDefault(); },
        stopPropagation: function() { e.stopPropagation(); }
      }, id, action, handle);
      if (dragState) {
        dragState.touchId = touch.identifier;
        isTouchInput = true;
      }
    }

    function startTouchPinch(e, touches, id) {
      var el = elements.find(function(item) { return item.id === id; });
      if (!el || touches.length < 2) return;
      var first = (dragState && findTouch(touches, dragState.touchId)) || touches[0];
      var second = touches.find(function(touch) { return touch.identifier !== first.identifier; });
      var distance = getTouchDistance(first, second);
      if (distance < 1) return;
      if (e.cancelable) e.preventDefault();
      e.stopPropagation();
      selectElement(id);
      dragState = {
        type: 'pinch',
        elId: id,
        touchId: first.identifier,
        secondTouchId: second.identifier,
        startDistance: distance,
        startFontSize: el.fontSize || 28,
        startWidth: el.width || 200,
        startImageWidth: el.width || 200,
        startImageHeight: el.height || 200
      };
      isTouchInput = true;
      if (modal) modal.classList.add('pd-dragging');
    }

    function onCanvasTouchStart(e) {
      if (e.currentTarget !== canvasEl || modal.hidden) return;
      touchMouseUntil = Date.now() + 700;
      var touches = canvasTouches(e);
      var targetEl = e.target.closest('.pd-element');
      if (touches.length >= 2) {
        if (dragState && dragState.type === 'pinch') {
          if (e.cancelable) e.preventDefault();
          return;
        }
        var id = dragState ? dragState.elId : (targetEl ? parseInt(targetEl.dataset.id, 10) : selectedElId);
        if (id !== null) startTouchPinch(e, touches, id);
        return;
      }
      if (touches.length !== 1 || dragState) return;
      var handle = e.target.closest('[data-handle]');
      if (handle && selectedElId !== null) {
        var position = handle.dataset.handle;
        startTouchDrag(e, selectedElId, position === 'rotate' ? 'rotate' : 'resize', position, touches[0]);
      } else if (targetEl) {
        var elementId = parseInt(targetEl.dataset.id, 10);
        selectElement(elementId);
        startTouchDrag(e, elementId, 'move', null, touches[0]);
      } else {
        selectElement(null);
      }
    }

    function onTouchEnd(e) {
      if (!isTouchInput || !dragState) return;
      if (e.type === 'touchcancel') {
        onDragEnd();
        return;
      }
      var touches = canvasTouches(e);
      var first = findTouch(touches, dragState.touchId);
      if (first && (dragState.type !== 'pinch' || findTouch(touches, dragState.secondTouchId))) return;
      if (touches.length >= 2) {
        startTouchPinch(e, touches, dragState.elId);
      } else if (touches.length === 1) {
        startTouchDrag(e, dragState.elId, 'move', null, touches[0]);
      } else {
        onDragEnd();
      }
    }

    function getEventCoords(e) {
      if (e.touches) {
        var touch = dragState ? findTouch(e.touches, dragState.touchId) : e.touches[0];
        return touch ? {clientX: touch.clientX, clientY: touch.clientY} : null;
      }
      return {clientX: e.clientX, clientY: e.clientY};
    }

    function startDrag(e, elId, action, handlePos){
      e.preventDefault(); e.stopPropagation();
      if (modal) {
    modal.classList.add('pd-dragging');
  }
      var el = elements.find(x=>x.id===elId); if(!el) return;
      var dom = elementsContainer.querySelector('[data-id="'+elId+'"]'); if(!dom) return;
      var coords=getEventCoords(e); var areaRect=area.getBoundingClientRect(); var r=dom.getBoundingClientRect();
      var elLeft=r.left-areaRect.left; var elTop=r.top-areaRect.top; var cx=elLeft+r.width/2; var cy=elTop+r.height/2;
      if(action==='move'){ dragState={type:'move', elId, startX:coords.clientX, startY:coords.clientY, startElX:el.x, startElY:el.y}; }
      else if(action==='resize'){
        dragState={type:'resize', elId, handle:handlePos, startX:coords.clientX, startY:coords.clientY, startWidth:r.width, startHeight:r.height, elementNaturalWidth:el.naturalWidth, elementNaturalHeight:el.naturalHeight, elementFontSize:el.fontSize};
      } else if(action==='rotate'){
        var sa = Math.atan2(coords.clientY-areaRect.top-cy, coords.clientX-areaRect.left-cx)*(180/Math.PI);
        dragState={type:'rotate', elId, startAngle:sa, startRotation:el.rotation, centerX:cx, centerY:cy};
      }
    }

   function onDragMove(e){
  if (!dragState || (isTouchInput !== !!e.touches)) return;
  if (e.cancelable) e.preventDefault();

  var coords = getEventCoords(e);
  if (!coords) return;
  var areaRect = area.getBoundingClientRect();
  var el = elements.find(function(x){ return x.id === dragState.elId; });
  if (!el) return;

  // 🟢 1) Bewegen (1 Finger / Maus)
  if (dragState.type === 'move') {
    var dx = coords.clientX - dragState.startX;
    var dy = coords.clientY - dragState.startY;

    var nx = dragState.startElX + (dx / areaRect.width) * 100;
    var ny = dragState.startElY + (dy / areaRect.height) * 100;

    if (gmKidsConfig.showBorder) {
      nx = Math.max(0, Math.min(100, nx));
      ny = Math.max(0, Math.min(100, ny));
    }

    updateElement(dragState.elId, { x: nx, y: ny });

  // 🔵 2) Resize über Handles (wie bisher)
  } else if (dragState.type === 'resize') {
    var dxr = coords.clientX - dragState.startX;
    var dyr = coords.clientY - dragState.startY;
    var handle = dragState.handle;
    var nw = dragState.startWidth;
    var nh = dragState.startHeight;

    if (handle.includes('r')) nw = Math.max(20, Math.min(1000, dragState.startWidth + dxr));
    else if (handle.includes('l')) nw = Math.max(20, Math.min(1000, dragState.startWidth - dxr));

    if (handle.includes('b')) nh = Math.max(20, dragState.startHeight + dyr);
    else if (handle.includes('t')) nh = Math.max(20, dragState.startHeight - dyr);

    if (el.type === 'text') {
      // Eck-Handles (tl, tr, bl, br) -> fontSize & width proportional
      if (['tl','tr','bl','br'].includes(handle)) {
        var baseWidth = dragState.startWidth || 1;
        var scale = nw / baseWidth;

        var minFs = 10;
        var maxFs = 200;
        var scaledFs = dragState.elementFontSize * scale;
        var newFs = Math.max(minFs, Math.min(maxFs, scaledFs));

        var effectiveScale = newFs / dragState.elementFontSize;
        var newWidth = dragState.startWidth * effectiveScale;
        newWidth = Math.max(20, Math.min(1000, newWidth));

        updateElement(dragState.elId, {
          fontSize: Math.round(newFs),
          width: newWidth
        });

      // Seiten-Handles -> nur Breite ändern
      } else {
        updateElement(dragState.elId, { width: nw });
      }

    } else {
      if (el.naturalWidth && el.naturalHeight) {
        nh = nw * (el.naturalHeight / el.naturalWidth);
      }
      updateElement(dragState.elId, { width: nw, height: nh });
    }

  // 🟣 3) NEU: Pinch-Zoom (2 Finger auf dem Element)
  } else if (dragState.type === 'pinch') {
    // Nur sinnvoll, wenn noch 2 Finger aufliegen
    if (!(e.touches && e.touches.length >= 2)) return;

    var t1 = findTouch(e.touches, dragState.touchId);
    var t2 = findTouch(e.touches, dragState.secondTouchId);
    if (!t1 || !t2) return;
    var dist = getTouchDistance(t1, t2);
    if (!dragState.startDistance) return;

    var scalePinch = dist / dragState.startDistance;

    if (el.type === 'text') {
      var minFsP = 10;
      var maxFsP = 200;

      var newFontSizeP = dragState.startFontSize * scalePinch;
      newFontSizeP = Math.max(minFsP, Math.min(maxFsP, newFontSizeP));

      var newWidthP = dragState.startWidth * (newFontSizeP / dragState.startFontSize);
      newWidthP = Math.max(20, Math.min(1000, newWidthP));

      updateElement(el.id, {
        fontSize: Math.round(newFontSizeP),
        width: newWidthP
      });

    } else if (el.type === 'image') {
      var newW = dragState.startImageWidth * scalePinch;
      var newH = dragState.startImageHeight * scalePinch;

      newW = Math.max(20, Math.min(2000, newW));
      newH = Math.max(20, Math.min(2000, newH));

      updateElement(el.id, {
        width: newW,
        height: newH
      });
    }

  // 🟡 4) Rotation (wie bisher)
  } else if (dragState.type === 'rotate') {
    var dom = elementsContainer.querySelector('[data-id="' + dragState.elId + '"]');
    if (!dom) return;

    var r = dom.getBoundingClientRect();
    var cx = (r.left + r.width / 2) - areaRect.left;
    var cy = (r.top + r.height / 2) - areaRect.top;

    var ca = Math.atan2(
      (coords.clientY - areaRect.top) - cy,
      (coords.clientX - areaRect.left) - cx
    ) * (180 / Math.PI);

    var nr = dragState.startRotation + (ca - dragState.startAngle);
    while (nr < 0) nr += 360;
    while (nr >= 360) nr -= 360;

    updateElement(dragState.elId, { rotation: Math.round(nr) });
  }
}

    function onDragEnd(e){
  if (e && e.type === 'mouseup' && isTouchInput) return;
  if (isTouchInput) touchMouseUntil = Date.now() + 700;
  dragState = null;
  isTouchInput = false;
  if (modal) {
    modal.classList.remove('pd-dragging');
  }
}


    area && area.addEventListener('mousedown', function(e){
      if (isTouchInput || Date.now() < touchMouseUntil) return;
      var h=e.target.dataset.handle;
      if(h==='rotate'){ if(selectedElId) startDrag(e, selectedElId, 'rotate'); }
      else if(h){ if(selectedElId) startDrag(e, selectedElId, 'resize', h); }
      else {
        var elDiv=e.target.closest('.pd-element');
        if(elDiv){ var id=parseInt(elDiv.dataset.id); selectElement(id); startDrag(e, id, 'move'); }
        else { selectElement(null); }
      }

    });
    canvasEl && canvasEl.addEventListener('touchstart', onCanvasTouchStart, {passive:false});


    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('touchmove', onDragMove, {passive:false});
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchend', onTouchEnd, {passive:false});
    document.addEventListener('touchcancel', onTouchEnd, {passive:false});
    window.addEventListener('blur', function() { onDragEnd(); });

    canvasEl && canvasEl.addEventListener('mousedown', function(ev){
      if (isTouchInput || Date.now() < touchMouseUntil) return;
      if(selectedElId!==null){
        var elDiv = elementsContainer.querySelector('[data-id="'+selectedElId+'"]');
        if(elDiv && !elDiv.contains(ev.target)) selectElement(null);
      }
    });

   async function createDesignSnapshot() {
  try {
    await waitForUsedFonts(elements);

    const canvasEl = document.getElementById('pd-canvas-' + sectionId);
    const areaEl   = document.getElementById('pd-area-' + sectionId);
    const bgImg    = canvasEl.querySelector('.pd-base-img');

    const canvasRect = canvasEl.getBoundingClientRect();
    const areaRect   = areaEl.getBoundingClientRect();

    const areaLeft   = areaRect.left   - canvasRect.left;
    const areaTop    = areaRect.top    - canvasRect.top;
    const areaWidth  = areaRect.width;
    const areaHeight = areaRect.height;

    const dpr     = window.devicePixelRatio || 1;
    const maxSize = 1200;
    const base    = Math.max(canvasRect.width, canvasRect.height);
    const scale   = Math.min(1, maxSize / base);

    const outW = Math.round(canvasRect.width  * dpr * scale);
    const outH = Math.round(canvasRect.height * dpr * scale);

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width  = outW;
    tempCanvas.height = outH;
    const ctx = tempCanvas.getContext('2d');

    ctx.scale(dpr * scale, dpr * scale);

    // Hintergrund
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvasRect.width, canvasRect.height);

    if (bgImg && bgImg.complete && bgImg.naturalWidth > 0) {
      ctx.drawImage(bgImg, 0, 0, canvasRect.width, canvasRect.height);
    }

    function getTextXAlignStart(el, lineWidth, maxWidth) {
      // Wir zeichnen IMMER mit textAlign = 'left'
      if (el.textAlign === 'center') {
        return -lineWidth / 2;
      } else if (el.textAlign === 'right') {
        return -lineWidth;
      } else {
        // "left" → Block links innerhalb des Bereichs ausrichten
        return -maxWidth / 2;
      }
    }

    ctx.save();
    ctx.beginPath();
    ctx.rect(areaLeft, areaTop, areaWidth, areaHeight);
    ctx.clip();

    for (const el of elements) {
      const domEl = elementsContainer.querySelector('[data-id="' + el.id + '"]');
      if (!domEl) continue;

      const elRect = domEl.getBoundingClientRect();

      const centerX = (elRect.left + elRect.width  / 2) - canvasRect.left;
      const centerY = (elRect.top  + elRect.height / 2) - canvasRect.top;

      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(((el.rotation || 0) * Math.PI) / 180);

      if (el.type === 'text') {
        const fontSize = el.fontSize || 36;
        const maxWidth = Math.max(10, el.width || 200);

        // 🔥 hier nutzen wir deine exakte Layout-Funktion
        const layout = pdLayoutText(ctx, el, maxWidth);

        pdSetCtxFont(ctx, el, fontSize);
        ctx.fillStyle    = el.color || '#000';
        ctx.textBaseline = 'alphabetic';
        ctx.textAlign    = 'left';

        for (let i = 0; i < layout.lines.length; i++) {
          const lineContent = layout.lines[i] || '';
          const lineGraphemes = window.PDDesignJSON.graphemes(lineContent);
          const baselineY   = layout.baselines[i] - layout.centerY;

          // Breite der Linie inkl. Letterspacing berechnen
          let lineWidth = 0;
          for (let c = 0; c < lineGraphemes.length; c++) {
            const ch = lineGraphemes[c];
            lineWidth += ctx.measureText(ch).width;
            if (c < lineGraphemes.length - 1) {
              lineWidth += (el.letterSpacing || 0);
            }
          }

          const startX = getTextXAlignStart(el, lineWidth, maxWidth);
          let currentX = startX;

          for (let c = 0; c < lineGraphemes.length; c++) {
            const ch = lineGraphemes[c];
            ctx.fillText(ch, currentX, baselineY);
            currentX += ctx.measureText(ch).width + (el.letterSpacing || 0);
          }
        }

      } else if (el.type === 'image') {
        const domImgWrapper = elementsContainer.querySelector('[data-id="' + el.id + '"]');
        const imgEl = domImgWrapper ? domImgWrapper.querySelector('img') : null;
        if (imgEl && imgEl.complete && imgEl.naturalWidth > 0) {
          const w = el.width || 200;
          const h = el.height || (el.naturalHeight && el.naturalWidth
            ? (w * el.naturalHeight) / el.naturalWidth
            : 200
          );
          ctx.drawImage(imgEl, -w / 2, -h / 2, w, h);
        }
      }

      ctx.restore();
    }

    ctx.restore();

    const dataUrl = tempCanvas.toDataURL('image/jpeg', 0.9);
    if (downloadBtn) downloadBtn.disabled = false;
    return dataUrl;

  } catch (err) {
    console.error('Snapshot error:', err);
    return null;
  }
}
var pdDesignScenes = {};
async function createElementsOnlySnapshot() {
  try {
    await waitForUsedFonts(elements);

    const canvasEl = document.getElementById('pd-canvas-' + sectionId);
    const areaEl   = document.getElementById('pd-area-' + sectionId);

    const areaRect   = areaEl.getBoundingClientRect();
    const areaWidth  = areaRect.width;
    const areaHeight = areaRect.height;

    const printWidth = 3000;
    const scale = printWidth / areaWidth;
    const outW  = Math.round(areaWidth  * scale);
    const outH  = Math.round(areaHeight * scale);

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width  = outW;
    tempCanvas.height = outH;
    const designRecorder = window.PDDesignJSON.record(tempCanvas, {side:'front',label:'front',areaWidth,areaHeight,scale});
    const ctx = designRecorder.ctx;

    ctx.setTransform(scale, 0, 0, scale, 0, 0);

    function getTextXAlignStart(el, lineWidth, maxWidth) {
      if (el.textAlign === 'center') {
        return -lineWidth / 2;
      } else if (el.textAlign === 'right') {
        return -lineWidth;
      } else {
        return -maxWidth / 2;
      }
    }

    for (const el of elements) {
      const domEl = elementsContainer.querySelector('[data-id="' + el.id + '"]');
      if (!domEl) continue;

      const elRect = domEl.getBoundingClientRect();

      const centerX = (elRect.left + elRect.width  / 2) - areaRect.left;
      const centerY = (elRect.top  + elRect.height / 2) - areaRect.top;

      designRecorder.begin(el, centerX, centerY);
      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(((el.rotation || 0) * Math.PI) / 180);

      if (el.type === 'text') {
        const fontSize = el.fontSize || 36;
        const maxWidth = Math.max(10, el.width || 200);

        const layout = pdLayoutText(ctx, el, maxWidth);
        designRecorder.layout(layout);

        pdSetCtxFont(ctx, el, fontSize);
        ctx.fillStyle    = el.color || '#000';
        ctx.textBaseline = 'alphabetic';
        ctx.textAlign    = 'left';

        for (let i = 0; i < layout.lines.length; i++) {
          const lineContent = layout.lines[i] || '';
          const lineGraphemes = window.PDDesignJSON.graphemes(lineContent);
          const baselineY   = layout.baselines[i] - layout.centerY;

          let lineWidth = 0;
          for (let c = 0; c < lineGraphemes.length; c++) {
            const ch = lineGraphemes[c];
            lineWidth += ctx.measureText(ch).width;
            if (c < lineGraphemes.length - 1) {
              lineWidth += (el.letterSpacing || 0);
            }
          }

          const startX = getTextXAlignStart(el, lineWidth, maxWidth);
          let currentX = startX;

          for (let c = 0; c < lineGraphemes.length; c++) {
            const ch = lineGraphemes[c];
            ctx.fillText(ch, currentX, baselineY);
            currentX += ctx.measureText(ch).width + (el.letterSpacing || 0);
          }
        }

      } else if (el.type === 'image') {
        const domImgWrapper = elementsContainer.querySelector('[data-id="' + el.id + '"]');
        const imgEl = domImgWrapper ? domImgWrapper.querySelector('img') : null;
        if (imgEl && imgEl.complete && imgEl.naturalWidth > 0) {
          const w = el.width || 200;
          const h = el.height || (el.naturalHeight && el.naturalWidth
            ? (w * el.naturalHeight) / el.naturalWidth
            : 200
          );
          ctx.drawImage(imgEl, -w / 2, -h / 2, w, h);
        }
      }

      ctx.restore();
      designRecorder.end();
    }

    pdDesignScenes['front'] = designRecorder.finish();
    return tempCanvas.toDataURL('image/png', 1.0);

  } catch (err) {
    console.error('Elements-only snapshot failed:', err);
    return null;
  }
}





    async function onElementsChanged(){
      void window.PDDesignJSON.prepareFonts(elements);
      currentDesignDataUrl = elements.length>0 ? await createDesignSnapshot() : null;
    }

    function pdDataUrlToFile(dataUrl, fileName){
      var parts = dataUrl.split(',');
      var mimeMatch = parts[0].match(/data:([^;]+)/);
      var mime = mimeMatch ? mimeMatch[1] : 'image/png';
      var binary = atob(parts[1]);
      var bytes = new Uint8Array(binary.length);
      for(var i=0;i<binary.length;i++) bytes[i]=binary.charCodeAt(i);
      return new File([bytes], fileName, { type:mime });
    }

       async function addToCart(extraItems){
      if (addCartBtn.disabled) return;
      var pf = productForm || findProductForm();
      if(!pf){ alert('Produktformular nicht gefunden.'); return; }

      var idInput  = pf.querySelector('[name="id"]');
      var variantId = idInput ? idInput.value : null;
      if(!variantId){
        alert('Bitte wähle eine Produktvariante.');
        return;
      }

      if(elements.length===0){
        alert('Bitte erstelle zuerst ein Design.');
        return;
      }

      var qtyVal = parseInt(qtyInput.value) || 1;
      var originalText = addCartBtn.textContent;

      addCartBtn.disabled = true;
      addCartBtn.textContent = 'Erstelle Druckdatei...';

      try{
        pdDesignScenes = {};
        void window.PDDesignJSON.prepareFonts(elements);
        var fullSnap   = await createDesignSnapshot();
        if(!fullSnap) throw new Error('Fehler beim Erstellen der Vorschau');

        var designOnly = await createElementsOnlySnapshot();
        if(!designOnly) throw new Error('Fehler beim Erstellen der Design-Ebene');

        addCartBtn.textContent = 'wird hinzugefügt';

        var printFileUrl = null;
        var designOnlyFileUrl = null;
        try {
          var uploadedFiles = await window.PDDesignJSON.uploadFiles('https://personalisierung.ecoverce.com/upload-design-geschenkemomente.php', [
            {dataUrl:fullSnap, category:'preview'},
            {dataUrl:designOnly, category:'print'}
          ]);
          printFileUrl = uploadedFiles[0];
          designOnlyFileUrl = uploadedFiles[1];
        } catch(uploadError) {
          console.warn('Externer Personalisierungs-Upload nicht verfügbar; Shopify-Dateiupload wird verwendet.', uploadError);
        }

        addCartBtn.textContent = 'Gute Wahl 🎉';

        // Line-item Properties für das Hauptprodukt
        var properties = {};
        var textCount  = 0;
        var imageCount = 0;

        elements.forEach(function(el){
          if(el.type==='text'){
            textCount++;
            properties['Text '+textCount]          = el.content;
            properties['Schriftart '+textCount]    = el.fontFamily.replace(/['"]/g,'').split(',')[0];
            properties['Schriftfarbe '+textCount]  = el.color;
          } else if(el.type==='image'){
            imageCount++;
          }
        });

        if(imageCount>0){
          properties['Bild'] = imageCount + ' Bild' + (imageCount>1?'er':'');
        }

        // 🔁 alle Bild-Uploads einsammeln
var uploadImgs = elements.filter(function(e){
  return e.type === 'image' && e.uploadedImageUrl;
});

// Wenn du durchnummerierte Keys im Backend willst:
uploadImgs.forEach(function(img, index){
  properties['_Original_Bild_' + (index + 1)] = img.uploadedImageUrl;
});

        if(printFileUrl) properties['_Druckvorschau'] = printFileUrl;
        if(designOnlyFileUrl) properties['_Druckdatei'] = designOnlyFileUrl;

        // Hauptartikel
        var mainItem = {
          id: variantId,
          quantity: qtyVal,
          properties: properties
        };

        var designJsonFile = await window.PDDesignJSON.file(
          [pdDesignScenes.front],
          {shop: gmKidsConfig.shop, productId: String(gmKidsConfig.productId), productTitle: gmKidsConfig.title, variantId: String(variantId), sectionId: sectionId},
          properties
        );
        var additionalFiles = {};
        if (!printFileUrl || !designOnlyFileUrl) {
          additionalFiles['_Druckvorschau'] = pdDataUrlToFile(fullSnap, 'druckvorschau.png');
          additionalFiles['_Druckdatei'] = pdDataUrlToFile(designOnly, 'druckdatei.png');
          elements.filter(function(el){ return el.type === 'image' && el.originalDataUrl; }).forEach(function(el,index){
            additionalFiles['_Original_Bild_' + (index + 1)] = pdDataUrlToFile(el.originalDataUrl, 'original-bild-' + (index + 1) + '.png');
          });
        }
        var cartRequestBody = window.PDDesignJSON.form(mainItem, extraItems, designJsonFile, additionalFiles);
        var cartResp = await fetch('/cart/add.js', {method:'POST', body:cartRequestBody});

        var cartResult = await cartResp.json();
        if(!cartResp.ok){
          throw new Error(cartResult.description || cartResult.message || 'Cart add failed');
        }

        // Modal schließen & Cart öffnen wie bisher
        modal.hidden = true;
        document.body.style.overflow = '';

        var header = document.querySelector('header, .header, [role="banner"]');
        if(header) header.style.removeProperty('display');

        document
          .querySelectorAll('[id*="trustbadge"], [id*="trusted"], ._1b4t9li, [class*="trustbadge"]')
          .forEach(function(b){ b.style.removeProperty('display'); });

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));

        var cd = document.querySelector('cart-drawer');
        if(cd && typeof cd.open === 'function'){
          cd.open();
        } else {
          cd = document.querySelector('[data-cart-drawer], #cart-drawer, .cart-drawer, [id*="cart"]');
          if(cd){
            cd.classList.add('active','is-open','open');
            cd.style.display='block';
          }
        }

      }catch(err){
        console.error('=== FEHLER ===', err);
        alert('Fehler beim Verarbeiten: '+err.message);
      }finally{
        addCartBtn.disabled = false;
        addCartBtn.textContent = originalText;
      }
    }


       


    function attachButton(){
      var pf = findProductForm();
      productForm=pf; if(!pf||!openBtn) return false;
      var submit=pf.querySelector('[type="submit"], button[name="add"]'); if(submit){ submit.insertAdjacentElement('beforebegin', openBtn); hideOriginalAddToCart(); return true; }
      return false;
    }
    if(!attachButton()){
      var obs=new MutationObserver(function(){ if(attachButton()) obs.disconnect(); });
      obs.observe(document.documentElement,{childList:true,subtree:true});
      setTimeout(function(){ obs.disconnect(); }, 5000);
    }

    // Pointer Handling außerhalb Element → Auswahl lösen
    canvasEl && canvasEl.addEventListener('mousedown', function(ev){
      if (isTouchInput || Date.now() < touchMouseUntil) return;
      if(selectedElId!==null){
        var elDiv=elementsContainer.querySelector('[data-id="'+selectedElId+'"]');
        if(elDiv && !elDiv.contains(ev.target)) selectElement(null);
      }
    });

    // Canvas-Inhalt in Farb-/Font-Popups kopieren und proportional skalieren
    function syncCanvasToModal(modalId) {
      var sectionRoot = document.getElementById('product-designer-' + gmKidsConfig.sectionId);
      if (!sectionRoot) return;

      var mainCanvas   = sectionRoot.querySelector('.pd-canvas');
      if (!mainCanvas) return;

      var mainArea     = mainCanvas.querySelector('.pd-area');
      var mainElements = mainArea ? mainArea.querySelector('.pd-elements') : null;
      if (!mainArea || !mainElements) return;

      var modal        = document.getElementById(modalId);
      if (!modal || modal.hidden) return;

      var modalCanvas  = modal.querySelector('.pd-canvas');
      var modalArea    = modalCanvas ? modalCanvas.querySelector('.pd-area') : null;
      var modalElements = modalArea ? modalArea.querySelector('.pd-elements') : null;
      if (!modalCanvas || !modalArea || !modalElements) return;

      // Bounding-Boxen auslesen
      var mainRect  = mainArea.getBoundingClientRect();
      var modalRect = modalArea.getBoundingClientRect();
      if (!mainRect.width || !modalRect.width) return;

      // Maßstab von Haupt-Canvas → Popup
      var scale = modalRect.width / mainRect.width;

      // Ziel leeren
      modalElements.innerHTML = '';

      // Wrapper, der komplett skaliert wird
      var wrapper = document.createElement('div');
      wrapper.style.position        = 'absolute';
      wrapper.style.left            = '0';
      wrapper.style.top             = '0';
      wrapper.style.width           = mainRect.width + 'px';
      wrapper.style.height          = mainRect.height + 'px';
      wrapper.style.transformOrigin = 'top left';
      wrapper.style.transform       = 'scale(' + scale + ')';

      // Inhalt aus Haupt-Canvas klonen
      var cloned = mainElements.cloneNode(true);
      cloned.style.position = 'absolute';
      cloned.style.left     = '0';
      cloned.style.top      = '0';

      // Interaktionen im Popup deaktivieren
      cloned.querySelectorAll('.pd-element').forEach(function (el) {
        el.style.pointerEvents = 'none';
      });

      wrapper.appendChild(cloned);
      modalElements.appendChild(wrapper);
    }





    // === Popups ===
window.openColorPopup = function (el) {
  const modal = document.getElementById("pd-color-modal");
  const saveBtn = modal.querySelector(".pd-color-save");
  const backBtn = modal.querySelector(".pd-color-back");
  const choices = modal.querySelectorAll(".color-choice");

  // 🎨 Aktuelle Farbe aus dem Element holen
  const originalColor = el.color || "#000000";
  let selected = originalColor;

  // Pop-up anzeigen
  modal.hidden = false;

  // 🖌️ Markiere die aktuelle Farbe im Raster
  choices.forEach((c) => {
    const isSelected = c.dataset.color.toLowerCase() === originalColor.toLowerCase();
    c.classList.toggle("selected", isSelected);

    // Klick auf Farbfeld = temporäre Vorschau
    c.onclick = function () {
      choices.forEach((x) => x.classList.remove("selected"));
      c.classList.add("selected");
      selected = c.dataset.color;

      // 🔥 Live-Vorschau direkt anwenden (nur temporär)
      updateElement(el.id, { color: selected });
    };
  });

  // ✅ Speichern = Farbe bleibt dauerhaft
  saveBtn.onclick = function () {
    updateElement(el.id, { color: selected });
    modal.hidden = true;
  };

  // ❌ Abbrechen = alte Farbe wiederherstellen
  backBtn.onclick = function () {
    updateElement(el.id, { color: originalColor });
    modal.hidden = true;
  };

  // 💡 Vorschau synchronisieren (Canvas-Inhalt reinladen)
  syncCanvasToModal("pd-color-modal");
};



// Globale Referenz fürs aktuelle Text-Element im Popup
window.__pdFontTarget = null;

window.openFontPopup = function (el) {
  window.__pdFontTarget = el;

  const modal = document.getElementById("pd-font-modal");
  const backBtn = modal.querySelector(".pd-font-back");
  const saveBtn = modal.querySelector(".pd-font-save");

  const trigger = modal.querySelector(".pd-faux-select-trigger");
  const valueEl = modal.querySelector(".pd-faux-select-value");
  const list = modal.querySelector(".pd-faux-options");
  const options = Array.from(list.querySelectorAll(".pd-faux-option"));
  const preview = modal.querySelector(".pd-font-preview");

  // 🔹 Vorschautext im Popup
  preview.textContent =
    el.content && el.content.trim() !== ""
      ? el.content
      : "Aa – Beispieltext in gewählter Schrift";

  // 🔹 Original-Schrift merken (für „Zurück“)
  const originalFont =
    el.fontFamily ||
    "Arial,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif";
  let selectedFont = originalFont;

  // Aktuelle Schrift anwenden
  setCurrentFont(originalFont);

  // Popup öffnen
  modal.hidden = false;
  syncCanvasToModal("pd-font-modal");

  trigger.setAttribute("aria-expanded", "false");
  list.hidden = true;

  // --- Dropdown ein/aus
  function toggleList(forceState) {
    const open = forceState != null ? forceState : list.hidden;
    list.hidden = !open;
    trigger.setAttribute("aria-expanded", String(open));
  }

  trigger.onclick = function () {
    toggleList(true);
  };

  // --- Auswahl: Live-Vorschau & temporäre Anwendung
  options.forEach(function (opt) {
    opt.onclick = function () {
      const font = opt.getAttribute("data-font");
      selectedFont = font;
      setCurrentFont(font);
      toggleList(false);

      // 🔥 Vorschau live im Canvas (temporär)
      updateElement(el.id, { fontFamily: font });
    };
  });

  // ✅ SPEICHERN: endgültig übernehmen
  saveBtn.onclick = function () {
    if (!window.__pdFontTarget) return;
    updateElement(window.__pdFontTarget.id, {
      fontFamily: selectedFont,
      fontWeight: 400, // normal
    });
    modal.hidden = true;
    window.__pdFontTarget = null;
  };

  // ❌ ZURÜCK: alte Schrift wiederherstellen
  backBtn.onclick = function () {
    if (!window.__pdFontTarget) return;
    updateElement(window.__pdFontTarget.id, {
      fontFamily: originalFont,
      fontWeight: 400,
    });
    modal.hidden = true;
    window.__pdFontTarget = null;
  };

  // --- Klick außerhalb schließt Dropdown
  function onDocClick(e) {
    if (!modal.contains(e.target)) {
      list.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }
  }
  document.addEventListener("click", onDocClick, { once: true });

  // --- ESC schließt Liste/Modal
  function onKey(e) {
    if (e.key === "Escape") {
      if (!list.hidden) {
        toggleList(false);
      } else {
        modal.hidden = true;
        window.removeEventListener("keydown", onKey);
      }
    }
  }
  window.addEventListener("keydown", onKey);

  // --- Hilfsfunktionen
  function setCurrentFont(font) {
    valueEl.textContent = shortFontName(font);
    valueEl.style.fontFamily = font;
    preview.style.fontFamily = font;
    options.forEach(function (o) {
      const isActive = o.getAttribute("data-font") === font;
      o.setAttribute("aria-selected", isActive ? "true" : "false");
      o.classList.toggle("selected", isActive);
    });
  }

  function shortFontName(fontFamily) {
    if (!fontFamily) return "Standard";
    return fontFamily.replace(/['"]/g, "").split(",")[0].trim();
  }
};


  })();

  // --- Farbwahl-Logik: Aktualisiere "Ausgewählt: ..." ---
document.addEventListener('DOMContentLoaded', function() {
  const colorButtons = document.querySelectorAll('.color-choice');
  const nameField = document.getElementById('pd-selected-color-name');

  if (!colorButtons.length || !nameField) return;

  // Standardfarbe aktiv setzen (erste Farbe)
  const firstBtn = colorButtons[0];
  firstBtn.classList.add('active');
  nameField.textContent = firstBtn.dataset.name || firstBtn.dataset.color;

  // Klick-Event für alle Buttons
  colorButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      // Vorherige aktive entfernen
      colorButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // Namen aktualisieren
      const colorName = this.getAttribute('data-name');
      nameField.textContent = colorName || this.dataset.color;
    });
  });
});




  